import React from "react";

const OrderSuccess = () => {
  return <div>Orders Succes</div>;
};

export default OrderSuccess;
